import NotificationSetting, {
  PATH as NOTIFICATION_SETTING,
} from './NotificationSetting';

export default { NotificationSetting };
export const PATH = { NOTIFICATION_SETTING };
